import { useState } from "react";
import PropTypes from "prop-types";
import { X, LoaderCircle } from "lucide-react";
import SnackbarUtils from "../../../lib/components/Snackbar/utils";

// Reusable Change Config Modal Component used for: HeartbeatInterval, WebSocketPingInterval, ChangeConfig, etc.
const ChangeConfigModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  configKey,
  inputLabel,
  defaultValue = "",
  isGenericConfig = false,
}) => {
  const [key, setKey] = useState(configKey || "");
  const [value, setValue] = useState(defaultValue);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          {isGenericConfig && (
            <>
              <label htmlFor="config-key-input" className="heartbeat-label">
                Key
              </label>
              <input
                id="config-key-input"
                type="text"
                value={key}
                onChange={e => setKey(e.target.value)}
                className="heartbeat-input"
                placeholder="Enter configuration key"
              />
            </>
          )}
          <label htmlFor="config-value-input" className="heartbeat-label">
            {inputLabel || "Value"}
          </label>
          <input
            id="config-value-input"
            type="text"
            value={value}
            onChange={e => setValue(e.target.value)}
            className="heartbeat-input"
            placeholder={`Enter ${isGenericConfig ? "value" : configKey.toLowerCase()}`}
          />
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </button>
          <button
            className="btn-submit"
            disabled={isSubmitting}
            onClick={async () => {
              setIsSubmitting(true);
              try {
                await onSubmit({ key: isGenericConfig ? key : configKey, value: value });
                SnackbarUtils.success("Command sent");
                onClose();
              } catch (e) {
                const msg =
                  e?.response?.data?.["error-message"] || e?.response?.data?.message || e?.message || JSON.stringify(e);
                SnackbarUtils.error(msg);
              } finally {
                setIsSubmitting(false);
              }
            }}
          >
            {isSubmitting ? <LoaderCircle className="animate-spin" size={16} /> : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

ChangeConfigModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  configKey: PropTypes.string,
  inputLabel: PropTypes.string,
  defaultValue: PropTypes.string,
  isGenericConfig: PropTypes.bool,
};

export default ChangeConfigModal;
